// these severity string are returned from psirt data,
// convert them to the int levels from cgi_bin/module/common/GUIGlobalVariables.h
export const SEVERITIES = {
  informational: MACROS.NOTICE.NOTICE_LEVEL_INFORMATION,
  low: MACROS.NOTICE.NOTICE_LEVEL_NOTIFICATION,
  medium: MACROS.NOTICE.NOTICE_LEVEL_WARNING,
  high: MACROS.NOTICE.NOTICE_LEVEL_ERROR,
  critical: MACROS.NOTICE.NOTICE_LEVEL_CRITICAL,
};
